import { render, staticRenderFns } from "./otaReport.vue?vue&type=template&id=059e1061&scoped=true"
import script from "./otaReport.vue?vue&type=script&lang=js"
export * from "./otaReport.vue?vue&type=script&lang=js"
import style0 from "./otaReport.vue?vue&type=style&index=0&id=059e1061&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "059e1061",
  null
  
)

export default component.exports